import { dbiBtnLogMes, dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { reportButtonLog } from '@intelligence/v3/_hooks/usePageLog';

import type { TRobloxRankCategory } from './robloxRankSourceConfig';

export const ROBLOX_GAME_RANK_PAGE_LOG_KEY_MAP: Record<TRobloxRankCategory, string> = {
  popular: 'casualGamesHubRobloxGameRankPopular',
  genres: 'casualGamesHubRobloxGameRankGenres',
  earnings: 'casualGamesHubRobloxGameRankEarnings',
  featured: 'casualGamesHubRobloxGameRankFeatured',
};

export const ROBLOX_GAME_RANK_DOWNLOAD_LOG_KEY = 'casualGamesHubRobloxGameRankDownloadClick';
export const ROBLOX_GAME_RANK_SOURCE_CHANGE_LOG_KEY = 'casualGamesHubRobloxGameRankSourceChange';

export const getRobloxGameRankPageLogKey = (
  category: TRobloxRankCategory,
): string => ROBLOX_GAME_RANK_PAGE_LOG_KEY_MAP[category]
  || ROBLOX_GAME_RANK_PAGE_LOG_KEY_MAP.popular;

export const getRobloxGameRankSearchPageLogInfo = (
  category: TRobloxRankCategory,
): { pageId: string; typeId: string } => {
  const pageLog = dbiPageLogMes[getRobloxGameRankPageLogKey(category)];

  return {
    pageId: pageLog?.pageId || '',
    typeId: pageLog?.typeId || '',
  };
};

export const reportRobloxGameRankDownloadLog = (
  category: TRobloxRankCategory,
): void => {
  const pageLog = dbiPageLogMes[getRobloxGameRankPageLogKey(category)];
  const btnLog = dbiBtnLogMes[ROBLOX_GAME_RANK_DOWNLOAD_LOG_KEY];

  if (!pageLog || !btnLog) {
    return;
  }

  reportButtonLog({
    ...btnLog,
    pageId: pageLog.pageId,
    extInfo: JSON.stringify({ category }),
  });
};

export const reportRobloxGameRankSourceChangeLog = (
  category: TRobloxRankCategory,
  source: string,
): void => {
  const pageLog = dbiPageLogMes[getRobloxGameRankPageLogKey(category)];
  const btnLog = dbiBtnLogMes[ROBLOX_GAME_RANK_SOURCE_CHANGE_LOG_KEY];

  if (!pageLog || !btnLog) {
    return;
  }

  reportButtonLog({
    ...btnLog,
    pageId: pageLog.pageId,
    extInfo: JSON.stringify({ category, source }),
  });
};
